import React from 'react';
import { VertButton as AntButton, Spin } from '@vertem-core/vertice-ds';
import { ButtonProps } from 'antd/lib/button';
import { getButtonStyles } from 'utils/getButtonConfig';

interface ButtonLargeProps extends Omit<ButtonProps, 'size' | 'onClick' | 'shape' | 'type'> {
  loading?: boolean;
  shape?: 'default' | 'round'; 
  size?: 'default' | 'small' | 'large'; 
  type?: 'default' | 'link' | 'highlight'; 
  onClick?: () => void; 
}

const ButtonLarge: React.FC<ButtonLargeProps> = ({ loading, size, type, onClick, ...props }) => {
  const mappedSize = size === 'default' ? 'default' : size;
  const buttonStyles = getButtonStyles();

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <AntButton
      {...props}
      className={`button-fml ${props.className || ''}`}
      size={mappedSize}
      style={{ 
        fontSize: 'var(--font-big)', 
        fontWeight: '600',
        ...(buttonStyles.padding && { padding: buttonStyles.padding }),
        ...(buttonStyles.boxShadow && { boxShadow: buttonStyles.boxShadow }),
        ...props?.style 
      }}
      type={type}
      onClick={handleClick}
      disabled={loading || props.disabled}
    >
      {loading ? <Spin /> : props.children}
    </AntButton>
  );
};

export default ButtonLarge;
